import { ReactNode } from 'react';
import { createContext } from 'react';

interface PlatformProviderProps {
  children: ReactNode;
}

export type Platform = 'user' | 'developer';

export interface PlatformContextType {
  selectedPlatform: Platform;
  setSelectedPlatform: (platform: Platform) => void;
}

// Create a context with default values for the user platform
export const PlatformContext = createContext<PlatformContextType>({
  selectedPlatform: 'user',
  setSelectedPlatform: () => {}, // No-op function
});

export function PlatformProvider({ children }: PlatformProviderProps) {
  // For the user platform, always use 'user' as the selected platform
  const value = {
    selectedPlatform: 'user' as Platform,
    setSelectedPlatform: () => {
      // No-op function, we no longer allow switching platforms
      console.log(
        'Platform switching is disabled. Please visit platform.jua.ai for developer features.',
      );
    },
  };

  return <PlatformContext.Provider value={value}>{children}</PlatformContext.Provider>;
}
